import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { ChainedRender } from 'Modules/core/react';

import { RouteContext } from '../../components/RouteContext';
import { routes } from '../../routes/routes';
import { LandingLayout } from '../../components/LandingLayout';


const allRoutes = Object.values(routes);

const Rus: ChainedRender = ({ Next }) => (
    <LandingLayout>
        <Switch>
            {allRoutes.map(route => (
                <Route
                    key={route.route}
                    path={route.route}
                    exact
                    render={() => (
                        <RouteContext.Provider value={route}>
                            {React.createElement(route.page)}
                        </RouteContext.Provider>
                    )}
                />
            ))}
            <Route component={Next} />
        </Switch>
    </LandingLayout>
);

export const LandingRender: ChainedRender = ({ Next }) => (
    <Switch>
        <Route render={() => <Rus Next={Next} />} />
    </Switch>
);

export const RedirectToHome: ChainedRender = () => <Redirect to='/' />;
